(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  const initCustomAnchor = () => {
    const formatSelector = (selector) => {
      if (!selector) return null;
      return (selector.startsWith('#') || selector.startsWith('.')) ? selector : '#' + selector;
    };

    const scrollToElement = (element) => {
      const header = document.querySelector('store-header.header') || document.querySelector('.header') || document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: Math.max(0, elementPosition - headerHeight),
        behavior: 'smooth'
      });
    };

    const handleScroll = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const rawSelector = urlParams.get('scroll_to');
      const scrollToSelector = formatSelector(rawSelector);
      if (scrollToSelector) {
        setTimeout(() => {
          try {
            const targetElement = document.querySelector(scrollToSelector);
            if (targetElement) {
              scrollToElement(targetElement);
              
              const newUrl = new URL(window.location.href);
              newUrl.searchParams.delete('scroll_to');
              window.history.replaceState({}, document.title, newUrl.toString());
            }
          } catch (error) {
            console.warn('Invalid selector for scroll target:', error);
          }
        }, 500); // Small delay to allow images/sections to render
      }
    };

    handleScroll();

    const initCustomAnchor = () => {
      document.querySelectorAll('.js-custom-anchor').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
          const rawSelector = this.getAttribute('data-target');
          const targetSelector = formatSelector(rawSelector);
          console.log(targetSelector, 'targetSelector')
          if (!targetSelector) return;
  
          e.preventDefault();
          
          const anchorUrl = new URL(this.href, window.location.origin);
          const currentUrl = new URL(window.location.href);
          const isLinkInDrawerMenu = this.closest('.main-menu__disclosure');
  
          if (anchorUrl.pathname === currentUrl.pathname && !isLinkInDrawerMenu) {
            try {
              const targetElement = document.querySelector(targetSelector);
              if (targetElement) {
                scrollToElement(targetElement);
              } else {
                window.location.href = this.href;
              }
            } catch (error) {
              console.warn('Invalid selector:', error);
              window.location.href = this.href;
            }
          } else {
            // Redirect to the target page with query param
            anchorUrl.searchParams.set('scroll_to', rawSelector);
            window.location.href = anchorUrl.toString();
          }
        });
      });
    }

    initCustomAnchor();
    document.addEventListener('custom-anchor:init', initCustomAnchor);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomAnchor);
  } else {
    initCustomAnchor();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
